import React, { useEffect } from 'react';

import Chocolat from 'chocolat';
import Masonry from 'react-masonry-css';

import { ResponsiveImage } from '/components/responsive-image/components';

const PhotoGrid = ({ photos }) => {
    const slides = photos.map(photo => ({
        src: photo.image.src,
        width: photo.image.width,
        height: photo.image.width,
        title: photo.title,
    }));

    const { api } = Chocolat(slides, {
        // options here
    });

    useEffect(() => {
        return () => {
            api.destroy();
        };
    });

    return (
        <Masonry
            breakpointCols={{
                default: 3,
                768: 2,
            }}
            className="photo-grid"
            columnClassName="photo-grid-column"
        >
            {photos.map((photo, index) => (
                <div className="photo-teaser" key={photo.url}>
                    <a className="photo-teaser__link" href={photo.url}>
                        <ResponsiveImage
                            images={[
                                { src: `${photo.image.src}?auto=format,compress&w=400`, width: 400, breakpoint: '400px' },
                            ]}
                            width={+photo.image.width}
                            height={+photo.image.height}
                            alt={photo.title}
                        />
                    </a>
                    <button className="photo-teaser__preview-button" onClick={() => { api.open(index); }}>
                        <svg viewBox="0 0 24 24">
                            <use xlinkHref="#icon-zoom-in" />
                        </svg>
                    </button>
                </div>
            ))}
        </Masonry>
    );
};

export { PhotoGrid };
